const Menu =  [
  { header: 'چاپچی' },
  {
    title: 'پیشخوان',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  {
    title: 'طراحی',
    group: 'design',
    component: 'design',
    icon: 'insert_photo',
    items: [
      { name: 'NewArt', title: 'افزودن طرح جدید', component: 'NewArt' },
      { name: 'HistoryArt', title: 'مدیریت طرح‌ها', href: '#/pages/reports/list/artworks' /* component: 'HistoryArt' */ },
    ]
  },
  {
    title: 'فروشگاه‌ها',
    group: 'store',
    component: 'store',
    icon: 'store',
    items: [
      { name: '/pages/store/add', title: 'فروشگاه جدید', component: '/pages/store/add' },
      { name: '/pages/store/modify', title: 'مدیریت فروشگاه‌ها', component: '/pages/store/modify' },
    ]
  },
  {
    title: 'سفارش محصول',
    group: 'orders',
    component: 'orders',
    icon: 'shopping_basket',
    items: [
      { name: '/pages/extra_artworks/', title: 'سفارش محصول', component: '/pages/extra_artworks/' },
      { name: '/pages/reports/list/my_orders', title: 'لیست سفارشات', href: '#/pages/reports/list/my_orders' },
    ]
  },
  { header: 'مالی' },
  { name: 'Deposit', icon: 'account_balance_wallet', title: 'افزایش موجودی' },
  { name: '/pages/manual_payment/add', icon: 'money', title: 'ثبت دستی پرداخت' },
  { name: '/pages/reports/list/invoices', href: '#/pages/reports/list/invoices', icon: 'receipt', title: 'فاکتورها' },
  { name: '/pages/reports/list/customer_orders', href: '#/pages/reports/list/customer_orders', icon: 'receipt', title: 'سفارشات مشتریان' },
  { name: '/pages/payments/', href: '#/pages/reports/list/payments' /* component: '/pages/payments/' */, icon: 'description', title: 'گزارش واریز بانکی' },
  {
    title: 'درآمدها',
    group: 'money',
    component: 'money',
    icon: 'money',
    items: [
      {
        href: '#/pages/reports/list/commissions',
        title: 'گزارش درآمدها',
        component: '/pages/reports/list/commissions'
      },
      { name: '/pages/commission/refinances', title: 'تسویه حساب', component: '/pages/commission/refinances' },
    ]
  },
  /* { header: 'سفارش' },
  {
    title: 'سفارش خدمات',
    group: 'orders',
    component: 'orders',
    icon: 'grade',
    items: [
      { name: 'NewServiceOrder', title: 'سفارش خدمات', component: 'NewServiceOrder' },
      { name: 'ServiceOrderHistory', title: 'لیست سفارشات خدمات', component: 'ServiceOrderHistory' },
    ]
  },
  {
    title: 'سفارش محصول',
    group: 'orders',
    component: 'orders',
    icon: 'shopping_basket',
    items: [
      { name: 'Order', title: 'سفارش محصول', component: 'Order' },
      { name: 'HistoryOrder', title: 'لیست سفارشات', component: 'HistoryOrder' },
    ]
  }, */
  { header: 'پشتیبانی' },
  {
    title: 'تیکت‌ها',
    group: 'tickets',
    component: 'tickets',
    icon: 'contact_support',
    items: [
      { name: '/pages/tickets/new', title: 'تیکت جدید', component: '/pages/tickets/new' },
      { name: '/pages/tickets/list', title: 'تیکت‌های من', href: '#/pages/reports/list/tickets' },
    ]
  },
  {
    title: 'وب‌سرویس',
    group: 'api',
    component: 'api',
    icon: 'link',
    items: [
      { name: '/pages/api/add', title: 'افزودن درگاه', component: '/pages/api/add' },
      { name: '/pages/api/modify', title: 'لیست درگاه‌ها', component: '/pages/api/modify' },
    ]
  },
];
// reorder menu
/* Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
}); */

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js